export const triggerUsabillaCampaign = (triggerName, customVariables) => {
  window.usabilla_live('data', {
    custom: customVariables,
  });
  return window.usabilla_live('trigger', triggerName);
};
